import { Badge } from "reactstrap";

import { ReusableViewReferenceFields } from "../../../types/PageInterfaces";
import { Field, Module } from "../../../types/TenantInterfaces";
import SectionRenderer from "../SectionRenderer";

const SubitemRenderer = ({
  module,
  field,
  subItemValues,
  defaultSub,
  handleChange,
  disableReadonlyFields,
  prefill,
  publicForm = false,
  reusableViewReferenceFields,
}: {
  module: Module;
  field: Field;
  subItemValues: Record<string, any>;
  defaultSub: any;
  handleChange: any;
  prefill: any;
  disableReadonlyFields?: boolean;
  publicForm?: boolean;
  reusableViewReferenceFields?: ReusableViewReferenceFields;
}) => {
  const fieldType = field.FieldType;
  const isMultiSubitem = fieldType === "MultiSubitem";

  const section = {
    Title: isMultiSubitem ? null : (
      <div className="d-flex justify-content-between">
        {field?.Name}
        <Badge className="align-self-center">
          {isMultiSubitem ? "Multi-Subitem" : "Subitem"}
        </Badge>
      </div>
    ),
    Fields: field?.SubitemFields?.map((f) => ({ Field: f, ColSpan: 1 })),
    Type: fieldType,
    DefaultSubitem: defaultSub,
    ParentField: field,
  };

  // TODO: Handle Subitem Prefill
  return (
    <div className="w-100">
      <SectionRenderer
        section={section}
        module={module}
        createMode={true}
        // @ts-ignore
        values={subItemValues}
        // @ts-ignore
        handleChange={(f, val, useNestedPayload = true) => {
          let payload;

          if (useNestedPayload) {
            payload = {
              [f.APIName]: val,
            };
          } else {
            payload = val;
          }
          handleChange(field, payload, true);
        }}
        prefill={prefill}
        publicForm={publicForm}
        reusableViewReferenceFields={reusableViewReferenceFields}
      />
    </div>
  );
};

export default SubitemRenderer;
